export default {
  lastLowestPrice: {
    id: 'product_card_last_lowest_price',
    defaultMessage: 'Last lowest price : {price}',
  },
  sellerFlashSalesDiscountTooltip: {
    id: 'seller_flash_sales_tag_tooltip_short',
    defaultMessage:
      'The lowest price for this product in this exact configuration on Back Market in the 30 days prior to {start_date}. This reference updates on {end_date}.',
  },
  moreInfoSRLabel: {
    id: 'product_card_more_info_sr_label',
    defaultMessage: 'More information',
  },
} as const
